import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { NSpin } from 'naive-ui';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    size: { default: 'small' },
    forApp: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { size: 'small' | 'large' | 'medium', forApp: boolean }



const classname = computed<string[]>(() => {
	const result = [];
	if (props.forApp) {
		result.push('spinner-container-app');
	}
	return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner-container", _unref(classname)])
  }, [
    _createVNode(_unref(NSpin), {
      size: __props.forApp ? 'large' : __props.size
    }, null, 8, ["size"])
  ], 2))
}
}

})